import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { EnvConfigurationService } from '../services/envconf.service';
import { CustomAuthService } from '../services/auth/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(CustomAuthService);

  const excludedPaths = [
    '/v1/auth/txn',
    '/v1/authenticate/',
    EnvConfigurationService.configuration.WELL_KNOWN
  ];

  // Auth transaction is public and uses its own API credentials.
  const authBackendUrl = EnvConfigurationService.configuration.AUTH_BACKEND_URL;
  const isExternalAuth = Boolean(authBackendUrl && req.url.startsWith(authBackendUrl));
  const shouldExclude = excludedPaths.some(path => req.url.includes(path));
  if (shouldExclude) {
    return next(req);
  }

  if (!authService.isAuthenticated()) {
    // Token guardado porém vencido = sessão perdida: volta ao login com aviso. Sem token (pré-login) a request segue.
    if (!isExternalAuth && authService.hasExpiredSession()) {
      authService.expireSession();
    }
    return next(req);
  }

  const token = isExternalAuth ? authService.getAuthToken() : authService.getToken();
  if (!token || token.trim() === '') {
    return next(req);
  }

  const authHeaders = isExternalAuth
    ? {
        Authorization: `Bearer ${token}`,
        'X-API-KEY': EnvConfigurationService.configuration.AUTH_TXN_API_KEY,
        'X-API-SECRET': EnvConfigurationService.configuration.AUTH_TXN_API_SECRET
      }
    : { Authorization: `Bearer ${token}` };

  const authReq = req.clone({ setHeaders: authHeaders });

  return next(authReq).pipe(
    catchError((error) => {
      if (!isExternalAuth && (error.status === 401 || error.status === 403)) {
        // 401 = sessão rejeitada (avisa no login); 403 mantém o logout silencioso.
        if (error.status === 401) {
          authService.expireSession();
        } else {
          authService.logout();
        }
      }
      return throwError(() => error);
    })
  );
};
